import AssessmentGapNotice from "../AssessmentGapNotice";
import AssessmentRiskConditionNotice from "../AssessmentRiskConditionNotice";
import { isRiskAssessmentCondition } from "../../helpers/assessmentGapType";

const getQuestionAssessmentGap = (question) => {
    if (!question?.assessment_gap) {
        return null;
    }

    return question.assessment_gap;
};

/**
 * Creates a QuestionExtension that shows AssessmentGapNotice when
 * the question has an open assessment_gap from the API.
 *
 * @param {Object} [options]
 * @param {boolean} [options.distinguishRiskConditions=false]
 *   When true, gaps with module slug `risk_assessment` use the risk-condition UI.
 * @returns {Function}
 */
export const createQuestionnaireAssessmentGapExtension = (options = {}) => {
    const { distinguishRiskConditions = false } = options;

    const QuestionnaireAssessmentGapExtension = (props) => {
        const gap = getQuestionAssessmentGap(props.question);

        if (!gap) {
            return null;
        }

        const systemData =
            gap.systemData
            || props.question?.systemData
            || props.question?.system_data
            || undefined;
        const questionId = props.question?.id;
        const gapId = gap.id;

        return (
            <div
                className="assessment-question-focus-target"
                data-assessment-question-id={questionId != null ? String(questionId) : undefined}
                data-assessment-gap-id={gapId != null ? String(gapId) : undefined}
                data-assessment-question-system-data={systemData}
            >
                {distinguishRiskConditions && isRiskAssessmentCondition(gap) ? (
                    <AssessmentRiskConditionNotice gap={gap} />
                ) : (
                    <AssessmentGapNotice gap={gap} />
                )}
            </div>
        );
    };

    QuestionnaireAssessmentGapExtension.displayName =
        "QuestionnaireAssessmentGapExtension";

    return QuestionnaireAssessmentGapExtension;
};

export default createQuestionnaireAssessmentGapExtension;
